export default "__VITE_ASSET__BoH_SFUJ__"